import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import VideoThumbnail from "./VideoThumbnail";
import VideoDetails from "./VideoDetails";
import VideoPreview from "./VideoPreview";
import { THUMBNAIL_WIDTH, THUMBNAIL_WITH_GAP } from "../utils/constants";

export default function DesktopVideoCarousel({
  videos,
  activeIndex,
  setActiveIndex,
  goToPrevious,
  goToNext,
  isLoading,
  desktopContainerRef,
  containerDimensions,
  translateX,
}) {
  const activeVideo = videos[activeIndex];

  return (
    <div ref={desktopContainerRef}>
      {/* Navigation Controls */}
      <div className="hidden xs:flex items-center gap-3">
        <button
          onClick={goToPrevious}
          disabled={videos.length <= 1}
          className="w-8 h-8 flex items-center justify-center bg-[#9F9F9F] opacity-70 rounded-full hover:opacity-100 disabled:opacity-30 disabled:cursor-not-allowed transition-all duration-300 focus:outline-none"
          aria-label={`Previous video (${activeIndex > 0 ? activeIndex : videos.length} of ${videos.length})`}
        >
          <ChevronLeft size={24} />
        </button>
        <button
          onClick={goToNext}
          disabled={videos.length <= 1}
          className="w-8 h-8 flex items-center justify-center bg-[#9F9F9F] opacity-70 rounded-full hover:opacity-100 disabled:opacity-30 disabled:cursor-not-allowed transition-all duration-300 focus:outline-none"
          aria-label={`Next video (${activeIndex < videos.length - 1 ? activeIndex + 2 : 1} of ${videos.length})`}
        >
          <ChevronRight size={24} />
        </button>
      </div>

      {/* Video Carousel */}
      <div className="flex flex-col gap-12">
        {/* Thumbnails Row */}
        <div className="relative overflow-hidden -mx-8 px-8">
          <div
            className="flex gap-6 items-start transition-transform duration-500 ease-in-out py-8"
            style={{
              transform: `translateX(-${translateX}px)`,
              width: `${videos.length * THUMBNAIL_WITH_GAP + 64}px`,
            }}
            role="tablist"
            aria-label="Video thumbnails"
          >
            {videos.map((video, index) => (
              <VideoThumbnail
                key={index}
                video={video}
                index={index}
                isActive={index === activeIndex}
                isLoading={isLoading}
                onClick={setActiveIndex}
                width={THUMBNAIL_WIDTH}
                height={144}
                className="rounded-md"
              />
            ))}
          </div>

          {/* Edge fade indicators for desktop */}
          {containerDimensions.width &&
            videos.length * THUMBNAIL_WITH_GAP >
              containerDimensions.width - 64 && (
              <>
                <div className="absolute left-0 top-0 bottom-0 w-16 bg-gradient-to-r from-[#0f0624] to-transparent pointer-events-none z-10" />
                <div className="absolute right-0 top-0 bottom-0 w-16 bg-gradient-to-l from-[#0f0624] to-transparent pointer-events-none z-10" />
              </>
            )}
        </div>

        {/* Bottom Details Section */}
        <div className="flex items-center justify-between py-6">
          {/* Left - Video Details */}
          <VideoDetails video={activeVideo} />

          {/* Right - Large Preview Thumbnail */}
          <VideoPreview video={activeVideo} isLoading={isLoading} />
        </div>
      </div>
    </div>
  );
}
